export const truncateText = (text: string, maxLength: number = 50) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const truncateAddress = (
  address: string,
  startLength: number = 10,
  endLength: number = 6,
) => {
  if (!address) return "";
  if (address.length <= startLength + endLength) return address;
  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
};
